import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { Button, IconButton, Stack, Typography } from "@mui/material";
import MDBox from "components/MDBox";

export default function ClarificationRenderer({ question, suggestions = [], onPick, onDismiss }) {
  if (!question || !Array.isArray(suggestions) || suggestions.length === 0) {
    return null;
  }

  return (
    <MDBox
      mt={1}
      sx={{
        borderRadius: "14px",
        border: "1px solid rgba(59, 130, 246, 0.18)",
        bgcolor: "rgba(248, 250, 252, 0.95)",
        px: 1.25,
        py: 0.75,
      }}
    >
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography sx={{ fontSize: "0.8rem", fontWeight: 600, lineHeight: 1.35 }}>{question}</Typography>
        {onDismiss ? (
          <IconButton
            size="small"
            aria-label="Hide suggestions"
            onClick={onDismiss}
            sx={{ p: 0.3, mt: -0.2, mr: -0.35 }}
          >
            <CloseRoundedIcon sx={{ fontSize: 14 }} />
          </IconButton>
        ) : null}
      </Stack>
      <Stack
        direction="row"
        spacing={0.75}
        mt={0.8}
        sx={{
          flexWrap: "nowrap",
          overflowX: "auto",
          overflowY: "hidden",
          pb: 0.25,
          "&::-webkit-scrollbar": { height: 6 },
        }}
      >
        {suggestions.map((suggestion) => (
          <Button
            key={suggestion.label}
            size="small"
            variant="contained"
            onClick={() => onPick?.(suggestion.prompt)}
            sx={{
              textTransform: "none",
              borderRadius: "999px",
              px: 1.35,
              py: 0.35,
              minHeight: 26,
              fontSize: "0.72rem",
              fontWeight: 500,
              whiteSpace: "nowrap",
              flexShrink: 0,
              color: "primary.main",
              bgcolor: "rgba(37, 99, 235, 0.09)",
              boxShadow: "none",
              border: "1px solid rgba(37, 99, 235, 0.24)",
              "&:hover": {
                bgcolor: "rgba(37, 99, 235, 0.15)",
                boxShadow: "none",
              },
            }}
          >
            {suggestion.label}
          </Button>
        ))}
      </Stack>
    </MDBox>
  );
}
